<div class="chat-viewer-audio-container my-3 mx-4">

    <div class="waveform-wrapper" #waveformWrapper [ngClass]="{
            'mode-idle': viewState === 'idle',
            'mode-recording': viewState === 'recording',
            'mode-paused': viewState === 'paused',
            'mode-review': viewState === 'review',
            'seekable': viewState === 'review'
        }" (mousedown)="onSeekStart($event)" (touchstart)="onSeekStart($event)">
        <div class="waveform-viewport">
            <div class="waveform-flatline" *ngIf="viewState !== 'review'"></div>
            <div class="waveform-bars-clip" [style.clip-path]="viewState === 'review' ? null : recordingRevealClipPath">
                <div class="waveform-bars-track" [class.is-flowing]="isRecordingFlowing">
                    <div class="waveform-bars-group" *ngFor="let group of waveformTrackGroups">
                        <span class="bar" *ngFor="let height of waveformHeights" [style.height.%]="height"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="waveform-cursor" [style.left.%]="waveformCursorPercent"></div>
    </div>

    <div class="timer-row" [ngSwitch]="viewState">
        <ng-container *ngSwitchCase="'recording'">
            <span class="rec-dot"></span>
            <span class="timer-text">{{ formatTime(recordElapsedSeconds) }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'paused'">
            <i class="fas fa-pause rec-paused-icon"></i>
            <span class="timer-text">{{ formatTime(recordElapsedSeconds) }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'review'">
            <span class="timer-text">{{ formatTime(playbackCurrentSeconds) }} - {{ formatTime(playbackDurationSeconds)
                }}</span>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <span class="timer-text">{{ formatTime(0) }}</span>
        </ng-container>
    </div>

    <div class="actions-row" [ngSwitch]="viewState">

        <ng-container *ngSwitchCase="'idle'">
            <button class="btn btn-light rounded-circle btn-icon-only" (click)="close()"
                [title]="('CANCELAR' | translate)">
                <i class="fas fa-times"></i>
            </button>
            <button class="btn btn-danger rounded-circle btn-icon-only" (click)="initiateRecording()"
                [title]="('COMECAR_GRAVAR' | translate)">
                <i class="fas fa-microphone"></i>
            </button>
        </ng-container>

        <ng-container *ngSwitchCase="'recording'">
            <button class="btn btn-light rounded-circle btn-icon-only" (click)="close()"
                [title]="('CANCELAR' | translate)">
                <i class="fas fa-times"></i>
            </button>
            <button class="btn btn-darkgray rounded-circle btn-icon-only" (click)="concluirGravacao()"
                [title]="('PARAR_GRAVAR' | translate)">
                <i class="fas fa-stop"></i>
            </button>
            <button class="btn btn-danger rounded-circle btn-icon-only" (click)="pauseRecording()"
                [title]="('PAUSAR_GRAVAR' | translate)">
                <i class="fas fa-pause"></i>
            </button>
        </ng-container>

        <ng-container *ngSwitchCase="'paused'">
            <button class="btn btn-light rounded-circle btn-icon-only" (click)="close()"
                [title]="('CANCELAR' | translate)">
                <i class="fas fa-times"></i>
            </button>
            <button class="btn btn-darkgray rounded-circle btn-icon-only" (click)="concluirGravacao()"
                [title]="('PARAR_GRAVAR' | translate)">
                <i class="fas fa-stop"></i>
            </button>
            <button class="btn btn-danger rounded-circle btn-icon-only" (click)="resumeRecording()"
                [title]="('CONTINUAR_GRAVACAO' | translate)">
                <i class="fas fa-microphone"></i>
            </button>
        </ng-container>

        <ng-container *ngSwitchCase="'review'">
            <button class="btn btn-light rounded-circle btn-icon-only" (click)="close()"
                [title]="('CANCELAR' | translate)">
                <i class="fas fa-times"></i>
            </button>
            <button class="btn btn-danger rounded-circle btn-icon-only" (click)="excluirGravacao()"
                [title]="('EXCLUIR_GRAVACAO' | translate)">
                <i class="fas fa-trash"></i>
            </button>
            <button class="btn btn-darkgray rounded-circle btn-icon-only" (click)="togglePlayback()"
                [title]="isPlaying ? ('PAUSAR' | translate) : ('REPRODUZIR' | translate)">
                <i class="fas" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
            </button>
            <button class="btn btn-success rounded-circle btn-icon-only" (click)="enviaAudio()" [disabled]="!blob"
                [title]="('ENVIAR' | translate)">
                <i class="fas fa-paper-plane"></i>
            </button>
        </ng-container>

    </div>

    <audio #audioPlayer style="display: none;" [src]="safeAudioUrl" (play)="onAudioPlay()" (pause)="onAudioPause()"
        (timeupdate)="onAudioTimeUpdate()" (ended)="onAudioEnded()"></audio>

</div>